import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const api = createApi({
    reducerPath: "api",
    tagTypes: [
        "Auth",
        "Profile",
        "Blogs",
        "Comments",
        "WebSettings",
        "Portfolios",
        "Services"
    ],

    baseQuery: fetchBaseQuery({
        // baseUrl: "https://backend-createch.onrender.com/api/",
        baseUrl: (process.env.REACT_APP_API_URL || "https://api.createchsquads.com") + "/api/",
        // baseUrl: "https://api.ssbwithisv.in/api/",
        // baseUrl: "https://learning-admin-panel-backend.onrender.com/api/v1/",
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),

    endpoints: (builder) => ({

        /** 👤 Get current user profile */
        getTerm: builder.query({
            query: () => "team",
            providesTags: ["Profile"],
        }),

        getBlogs: builder.query({
            query: (page = 1) => `blogs?page=${page}`,
            providesTags: ["Profile"],
        }),
        
        getBlogsById: builder.query({
            query: (id) => `blogs/id/${id}`,
            providesTags: ["Profile"],
        }),

        getBlogBySlug: builder.query({
            query: (slug) => `blogs/slug/${slug}`,
            providesTags: ["Profile"],
        }),

        getCareer: builder.query({
            query: () => "career",
            providesTags: ["Profile"],
        }),

        // ✅ added contact form submit mutation
        submitContact: builder.mutation({
            query: (data) => ({
                url: "contact",
                method: "POST",
                body: data,
            }),
        }),

        // ✅ added comment submit mutation
        submitComment: builder.mutation({
            query: (data) => ({
                url: "comments",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Comments"],
        }),

        // ✅ added get comments for blog
        getCommentsByBlogId: builder.query({
            query: (blogId) => `comments/blog/${blogId}`,
            providesTags: ["Comments"],
        }),

        // ==================== 🔐 PERMISSIONS ====================

        /** ✨ Create new permission (Superadmin only) */


        // ✅ added get web settings
        getWebSettings: builder.query({
            query: () => "web-settings",
            providesTags: ["WebSettings"],
        }),

        getPortfolios: builder.query({
            query: () => "portfolio",
            providesTags: ["Portfolios"],
        }),

        getServices: builder.query({
            query: () => "services",
            providesTags: ["Services"],
        }),

    }),
});

// ==================== 🎯 EXPORT HOOKS ====================

export const {
    // 🔐 Auth

    // useGetTermQury

    useGetTermQuery,
    useGetBlogsQuery,
    useGetCareerQuery,
    useGetBlogsByIdQuery,
    useSubmitContactMutation, // ✅ added
    useSubmitCommentMutation, // ✅ added
    useGetCommentsByBlogIdQuery, // ✅ added
    useGetWebSettingsQuery, // ✅ added
    useGetPortfoliosQuery, // ✅ added
    useGetServicesQuery, // ✅ added
    useGetBlogBySlugQuery // ✅ added
} = api;
